import "./MarineAerospace.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhyMarineAerospace from "./sections/WhyMarineAerospace";
import MilSpecNameplatesAndDpm from "./sections/MilSpecNameplatesAndDpm";
import StandardsTable from "./sections/StandardsTable";
import TraceabilityRecurringProcess from "./sections/TraceabilityRecurringProcess";
import HowToStart from "./sections/HowToStart";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function MarineAerospacePage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhyMarineAerospace />
      <MilSpecNameplatesAndDpm />
      <StandardsTable />
      <TraceabilityRecurringProcess />
      <HowToStart />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}